// extracted by mini-css-extract-plugin
export var link = "socialLinks-module--link--mye8j";
export var links = "socialLinks-module--links--kyco-";